import React, { useState } from 'react';

function Header() {
  const [btnClass, setBtnClass] = useState('blue-color');

  function toggleColor() {
    setBtnClass(btnClass === 'blue-color' ? 'orange-color' : 'blue-color');
  }

  return (
    <div>
      <header
        style={{ backgroundColor: '#202E3F' }}
        id="header"
        class="fixed-top navbar"
      >
        <div class="container d-flex align-items-center">
          <h1 class="logo me-auto">
            <a href="index.html">Softskart</a>
          </h1>

          <nav id="navbar" class="navbar navbar-expand-lg">
            <ul>
              <li>
                <a class="nav-link scrollto active" href="#hero">
                  Home
                </a>
              </li>
              <li>
                <a class="nav-link scrollto" href="#about">
                  About Us
                </a>
              </li>
              <li>
                <a class="nav-link scrollto" href="#services">
                  Services
                </a>
              </li>
              <li>
                <a class="nav-link scrollto" href="#portfolio">
                  Portfolio
                </a>
              </li>
              <li>
                <a class="nav-link scrollto" href="#team">
                  Team
                </a>
              </li>
              <li class="dropdown">
                <a href="#">
                  <span>More</span> <i class="bi bi-chevron-down"></i>
                </a>
                <ul>
                  <li>
                    <a href>Blog</a>
                  </li>
                  {/* <li class="dropdown"><a href><span>Government Schemes</span> <i class="bi bi-chevron-right"></i></a>
                <ul>
                  <li><a href>Deep Drop Down 1</a></li>
                  <li><a href>Deep Drop Down 2</a></li>
                  <li><a href>Deep Drop Down 3</a></li>
                  <li><a href>Deep Drop Down 4</a></li>
                  <li><a href>Deep Drop Down 5</a></li>
                </ul>
              </li> */}
                  <li>
                    <a href>Advisory Body</a>
                  </li>
                  <li>
                    <a href>Internship / Jobs</a>
                  </li>
                  {/* <li><a href>Certifications</a></li> */}
                </ul>
              </li>
              <li>
                <a class="nav-link scrollto" href="#contact">
                  Contact
                </a>
              </li>
              <li>
                <a class="getstarted scrollto" href="#about">
                  Get Started
                </a>
              </li>
            </ul>
            <i class="bi bi-list mobile-nav-toggle"></i>
          </nav>
        </div>
      </header>
    </div>
  );
}

export default Header;
